import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { getUserRole } from "../../utils/getUserRole";
import "./Navbar.css";
import logo from "../../assets/logo.png";
import { FaLock } from "react-icons/fa";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const navRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const [mobileOpen, setMobileOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const updateIndicator = () => {
      const activeLink = navRef.current?.querySelector(".nav-center a.active");
      if (activeLink) {
        const { offsetLeft, offsetWidth } = activeLink;
        setIndicatorStyle({
          left: offsetLeft + "px",
          width: offsetWidth + "px",
        });
      }
    };

    updateIndicator();
    window.addEventListener("resize", updateIndicator);
    return () => window.removeEventListener("resize", updateIndicator);
  }, [location]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        const role = await getUserRole(currentUser.uid);
        setIsAdmin(role === "admin");
      } else {
        setIsAdmin(false);
      }
    });
    return unsubscribe;
  }, []);

  const toggleMenu = () => setMobileOpen((prev) => !prev);
  const closeMenu = () => setMobileOpen(false);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
  };

  return (
    <nav className="navbar default-nav">
      <div className="nav-spacer"></div>
      <div className="navbar-inner">
        {/* Logo */}
        <div className="nav-left">
          <img
            src={logo}
            alt="DeClerck's Goldens logo"
            className="logo overlapping-logo"
          />
        </div>

        {/* Nav Links + Auth Buttons */}
        <div
          className={`nav-center-wrapper ${mobileOpen ? "open" : ""}`}
          ref={navRef}
        >
          <ul className="nav-center" onClick={closeMenu}>
            <NavLink to="/" end>Home</NavLink>
            <NavLink to="/puppies">Puppies</NavLink>
            <NavLink to="/puppy-application">Application</NavLink>
            <NavLink to="/studs">Studs</NavLink>
            <NavLink to="/gallery">Gallery</NavLink>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/contact">Contact</NavLink>
            {isAdmin && <NavLink to="/admin">Admin</NavLink>}
          </ul>
          {/* AUTH BUTTONS INSIDE THE MOBILE MENU */}
          <div className="nav-auth-mobile">
            {!user ? (
              <>
                <NavLink
                  to="/login"
                  className="cta-button nav-login"
                  onClick={closeMenu}
                >
                  <FaLock style={{ marginRight: "0.7rem", fontSize: "1.09em" }} />
                  Login
                </NavLink>
                <NavLink
                  to="/register"
                  className="cta-button nav-register"
                  onClick={closeMenu}
                >
                  Register
                </NavLink>
              </>
            ) : (
              <button
                onClick={() => { handleLogout(); closeMenu(); }}
                className="cta-button nav-login"
              >
                Logout
              </button>
            )}
          </div>
          <span className="nav-indicator" style={indicatorStyle}></span>
        </div>

        {/* Desktop Auth Buttons */}
        <div className="nav-right">
          {!user ? (
            <>
              <NavLink to="/login" className="cta-button small">
                Login
              </NavLink>
              <NavLink to="/register" className="cta-button small outline">
                Register
              </NavLink>
            </>
          ) : (
            <button onClick={handleLogout} className="cta-button small">
              Logout
            </button>
          )}
        </div>

        {/* Hamburger */}
        <button
          className={`hamburger ${mobileOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
